import { Form, Input, Modal, Select, Spin } from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import { Constant } from '../../../config';
import '../style.css';

class AlertWhitelistMemberForm extends Component {
  state = {
    data: [],
    isLoading: false,
    value: undefined,
  };

  componentDidUpdate = async (prevProps) => {
    const { data: pd } = prevProps;
    const { data: d, form } = this.props;

    if (d && d.member_id !== pd.member_id) form.setFieldsValue(d);
  };

  handleCancelModal = () => {
    const { onCancel, form } = this.props;

    form.resetFields();
    onCancel();
  };

  handleChange = (value) => {
    this.props.form.setFieldsValue({
      member_id: +value,
    });
    this.props.form.setFields({
      email: {
        value: undefined,
        errors: undefined,
      },
    });
  };

  handleSearch = async (value) => {
    if (value.length < 3) {
      this.setState({ data: [] });
      return;
    }

    this.setState({ isLoading: true });

    let d = [];
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.MEMBER_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      params: {
        page: 1,
        limit: 10,
        search: value,
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined. 1");
      if (!resp.data.data) throw new Error("Response key 'data' is undefined. 2");

      resp.data.data.forEach((r) => {
        d.push({
          value: r.id,
          text: r.email,
        });
      });
    } catch (e) {
      console.error(e);
    }

    this.setState({ data: d, isLoading: false });
  };

  handleSubmit = () => {
    const memberID = this.props.form.getFieldValue('member_id');
    if (!memberID) {
      this.props.form.setFields({
        email: {
          value: undefined,
          errors: [new Error('กรุณากรอกอีเมล')],
        },
      });
    }

    this.props.onCreate();
  };

  render() {
    const { visible, form, flagCreateOrUpdateForm, loading } = this.props;
    const { getFieldDecorator } = form;
    const okText = flagCreateOrUpdateForm ? 'เพิ่ม' : 'แก้ไข';
    const options = this.state.data.map((d) => (
      <Select.Option key={d.value} value={d.value}>
        {d.text}
      </Select.Option>
    ));
    const title = `${okText} Alert whitelist member`;

    return (
      <Modal
        cancelText="ยกเลิก"
        maskClosable={false}
        okText={okText}
        onCancel={this.handleCancelModal}
        onOk={this.handleSubmit}
        style={{ top: 20 }}
        title={title}
        visible={visible}
        notFoundContent={true ? <Spin size="small" /> : null}
      >
        <Spin spinning={loading} tip="กำลังบันทึกข้อมูล...">
          <Form className="alert_form">
            {getFieldDecorator('id')(<Input type="hidden" />)}
            {getFieldDecorator('member_id')(<Input type="hidden" />)}
            <Form.Item label="Email">
              {getFieldDecorator('email')(
                <Select
                  showSearch
                  placeholder="เช่น help@movider.co"
                  filterOption={false}
                  notFoundContent={this.state.isLoading ? <Spin size="small" /> : null}
                  onSearch={this.handleSearch}
                  onChange={this.handleChange}
                >
                  {options}
                </Select>,
              )}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default Form.create({ name: 'alert_whitelist_member_form' })(
  AlertWhitelistMemberForm,
);



// WEBPACK FOOTER //
// ./src/containers/Keyword/AlertWhitelistMember/form.js